import React from 'react';

/**
 * Monogram avatar used for both project marks and people. Two tones:
 *   default — neutral surface fill (text-2 over bg-surface-2)
 *   accent  — sage-tinted (accent-text over accent-soft) — use for
 *             the active project card / list row
 *
 * `size` controls both the box and the font (font is 36% of size).
 * Border-radius scales as 28% of size so the corner-roundness reads
 * the same at 22px (PM avatar) and 34px (project card avatar).
 */
export default function Avatar({ initials, size = 32, accent = false, style }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.28,
        background: accent ? 'var(--accent-soft)' : 'var(--bg-surface-2)',
        color: accent ? 'var(--accent-text)' : 'var(--text-2)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.36,
        fontWeight: 600,
        border: '1px solid var(--border-subtle)',
        fontFamily: 'var(--font-mono)',
        letterSpacing: '-0.02em',
        flexShrink: 0,
        userSelect: 'none',
        ...style,
      }}
    >
      {initials}
    </div>
  );
}
